// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1KhzO","uploadWrapper":"style_uploadWrapper__2zcNV","dottedWrapper":"style_dottedWrapper__3tvEp","circle":"style_circle__3kQim","text":"style_text__c_WFc"};